export const aboutPage = () =>
  import("./AboutPage").then((m) => ({ Component: m.AboutPage }));
